export enum UserRole {
  Admin = 1,
  Youth = 2,
  Host = 3,
  Parent = 4,
}
